import { useParams } from 'react-router-dom';
import Dashboard, { DashboardRow, DashboardSection, DashboardSectionTitle } from '@g17eco/molecules/dashboard';
import { QUESTION } from '@constants/terminology';
import { CTAdminBreadcrumbs } from '@apps/company-tracker/components/breadcrumbs/CTAdminBreadcrumbs';
import { generateUrl } from '@routes/util';
import { ROUTES } from '@constants/routes';
import { QuestionValueListManagement } from '@features/question-management/value-list-management/QuestionValueListManagement';
import { FeatureStability } from '@g17eco/molecules/feature-stability';

export const AdminQuestionValueListRoute = () => {
  const { initiativeId, utrId } = useParams<{ initiativeId: string, utrId: string }>();

  return (
    <div className='admin-dashboard'>
      <Dashboard>
        <DashboardRow>
          <CTAdminBreadcrumbs
            initiativeId={initiativeId}
            breadcrumbs={[
              {
                label: `${QUESTION.CAPITALIZED_SINGULAR} management`,
                url: `${generateUrl(ROUTES.ADMIN_DASHBOARD, { initiativeId })}/questions`,
              },
              {
                label: 'Manage dropdown options',
              },
            ]}
          />
        </DashboardRow>
        <DashboardSectionTitle title={<>Manage dropdown options <FeatureStability stability='beta' /></>} />
        <DashboardSection>
          <QuestionValueListManagement initiativeId={initiativeId} utrId={utrId} />
        </DashboardSection>
      </Dashboard>
    </div>
  );
};
